import React, { Component } from "react";
import Accordion from "./AccordionView";
import _ from "lodash";

export default class SidebarContent extends Component {
  render() {
    //Group here
    let items = this.props.items;
    let groupBy = this.props.groupBy;
    let groupedItems = _(items);
    let groupNames = {
      ruleIndex: "",
      pageNo: "Page",
      ruleNo: "",
    };

    groupedItems = groupedItems.sortBy((item) => item.pageNo);

    //Sorting should be integer based ie R9 shd come first compared to R31
    //Trying to avoid this hardcoding :(
    if (groupBy !== "pageNo")
      groupedItems = groupedItems.sortBy((item) => {
        return parseInt(((item[groupBy] || item.pageNo) + "").replace("R", ""));
      });

    groupedItems = groupedItems
      .groupBy((item) => {
        let groupName = groupNames[groupBy];
        //Fallback Case
        if (!item[groupBy]) {
          return "Page " + item.pageNo;
        }
        return groupName + " " + item[groupBy];
      })
      .value();

    return (
      <div className="annotation-container">
        {!items.length && !this.props.loader ? (
          <div className="message-container">
            {`No ${
              this.props.viewType === "annotated"
                ? "annotations"
                : this.props.viewType
            } Found`}
          </div>
        ) : (
          <Accordion {...this.props} groupedItems={groupedItems} />
        )}
      </div>
    );
  }
}
